/** Favicon lookup for web citation badges; the service URL is overridable per environment. */
const FAVICON_SERVICE_URL =
  import.meta.env.VITE_FAVICON_SERVICE_URL || 'https://www.google.com/s2/favicons';

const FAVICON_SIZE = 64;

export function getSourceHostname(url: string): string | null {
  try {
    return new URL(url).hostname.replace(/^www\./, '') || null;
  } catch {
    return null;
  }
}

export function getSourceFaviconUrl(url: string): string | null {
  const hostname = getSourceHostname(url);
  if (!hostname) return null;
  return `${FAVICON_SERVICE_URL}?domain=${encodeURIComponent(hostname)}&sz=${FAVICON_SIZE}`;
}
